import React from 'react';

const quizInstanceAdminStatusContext = React.createContext(null);

export default quizInstanceAdminStatusContext;